import { TextCombination } from "@/components/_rebrand/TextCombination";
import Image from "next/image";

export type SectionProps = {
  label: string;
  title: string;
  description: string;
  image: string;
}

type SectionComponentProps = SectionProps & {
  id: string;
}

export const Section = ({ id, label, title, description, image }: SectionComponentProps) => {
  return (
    <div id={id} className="py-2xl flex flex-col gap-xl scroll-mt-10">
      <TextCombination className="md:hidden" type="h3p2" headingLevel="h3" align="left" eyebrow={label} title={title} description={description} />
      <TextCombination className="hidden md:block" isHeadingBalanced={false} type="h3p2" headingLevel="h3" align="left" title={title} description={description} />
      <Image className="w-full" src={image} alt={title} width={800} height={800} />
    </div>
  )
}
